import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { BadRequest } from './pages/404';
import { Receipt } from './pages/receipt';
import {ReceiptTicketing} from "./pages/receipt-ticketing";

export function App(props) {
    return (
        <Router>
            <Routes>
                <Route path="/receipt/:id" element={<Receipt />} />
                <Route path="/receipt/ticketing/:id" element={<ReceiptTicketing />} />
                <Route path="*" element={<BadRequest />} />
            </Routes>
        </Router>
    );
}
